import { getToken } from "@/lib/api";

/** Where the landing page's buttons lead. Inside the app they are in-app routes. A standalone copy of the page,
 *  built with REACT_APP_LANDIN_APP_URL, links out to the app at that address instead (opening in a new tab). */
export const APP_URL = (process.env.REACT_APP_LANDIN_APP_URL || "").replace(/\/+$/, "");
export const external = Boolean(APP_URL);

/** The letting agent's way in: the login page, or the dashboard when already signed in. */
export const agentDestination = () => {
  if (external) return `${APP_URL}/login`;
  try {
    return getToken() ? "/" : "/login";
  } catch {
    return "/login";
  }
};

/** Props for a link to `to`: a router link inside the app, or a plain link out to the app in a new tab. */
export const linkProps = (to) => (to.startsWith("http") ? { href: to, target: "_blank", rel: "noopener noreferrer" } : { to });
